<template>
  <v-dialog v-model="showDialog" max-width="340px" persistent>
    <v-card>
      <v-app-bar dark color="primary">
        <h3>{{$t('profile.passwordResetHeader')}}</h3>
      </v-app-bar>
      <ValidationObserver ref="changePasswordForm" v-slot="{ invalid }">
        <v-form @submit.prevent="onSubmit">
          <v-card-text>
            <v-col v-if="!responseSuccess">
              <v-row>
                <ValidationProvider name="passwordOld" slim mode="eager" :rules="passwordRule" v-slot="{ errors }">
                  <v-text-field
                    prepend-icon="person"
                    :type="showPassword.old ? 'text' : 'password'"
                    :label="$t('profile.passwordResetPlaceholderOld')"
                    :error-messages="errors[0]"
                    @click:append="showPassword.old = !showPassword.old"
                    :append-icon="showPassword.old ? icons.mdiEye : icons.mdiEyeOff"
                    v-model="password.old"></v-text-field>
                </ValidationProvider>
              </v-row>
              <v-row>
                <ValidationProvider name="passwordNew" slim mode="eager" :rules="passwordRule" v-slot="{ errors }">
                  <v-text-field
                    prepend-icon="person"
                    :type="showPassword.new ? 'text' : 'password'"
                    :label="$t('profile.passwordResetPlaceholderNew')"
                    :error-messages="errors[0]"
                    @click:append="showPassword.new = !showPassword.new"
                    :append-icon="showPassword.new ? icons.mdiEye : icons.mdiEyeOff"
                    v-model="password.new"></v-text-field>
                </ValidationProvider>
              </v-row>
              <v-row>
                <ValidationProvider name="passwordNewRepeat" slim mode="custom" rules="required|compareFields:@passwordNew" v-slot="{ errors }">
                  <v-text-field
                    prepend-icon="person"
                    :type="showPassword.newRep ? 'text' : 'password'"
                    :label="$t('profile.passwordResetPlaceholderNewRepeat')"
                    :error-messages="errors[0]"
                    @click:append="showPassword.newRep = !showPassword.newRep"
                    :append-icon="showPassword.newRep ? icons.mdiEye : icons.mdiEyeOff"
                    v-model="password.newRep"></v-text-field>
                </ValidationProvider>
              </v-row>

            </v-col>

            <v-alert dense type="warning" class="text-caption" v-if="responseError">
              {{$t('profile.passwordResetError')}}
            </v-alert>

            <v-alert dense type="success" class="text-caption" v-if="responseSuccess">
              {{$t('profile.passwordResetSuccess')}}
            </v-alert>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="button" text color="primary" v-if="!responseSuccess" @click="closeDialog">{{$t('profile.passwordResetButtonCancel')}}</v-btn>
            <v-btn type="submit" text color="primary" :disabled="invalid" v-if="!responseSuccess">{{$t('profile.passwordResetButtonSave')}}</v-btn>
            <v-btn type="button" text color="primary" v-if="responseSuccess" @click="finishUpdatePassword">{{$t('profile.passwordResetButtonOK')}}</v-btn>
          </v-card-actions>
        </v-form>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
  import {BASE_API_URL} from '@/store'
  import {mdiEye, mdiEyeOff} from '@mdi/js';
  import {
    isCustomRegexValidationRuleAvailable
  } from '@/utils/auth/validation';

  export default {
    name: 'ResetPasswordDialog',
    props: ['showDialog'],
    data() {
      return {
        responseError: false,
        responseSuccess: false,
        password: {
          old: '',
          new: '',
          newRep: ''
        },
        showPassword: {
          old: false,
          new: false,
          newRep: false
        },
        icons: {mdiEye, mdiEyeOff},
      }
    },
    computed: {
      passwordRule() {
        const isCustomPasswordRuleAvailable = isCustomRegexValidationRuleAvailable('password_validator');

        return isCustomPasswordRuleAvailable
          ? 'required|min:8|password_validator'
          : 'required|min:8';
      }
    },
    methods: {
      async onSubmit() {
        let body = JSON.stringify({
          'password_old': this.password.old,
          'password_new': this.password.new,
          'password_new_rep': this.password.newRep
        });

        try {
          let response = await this.axios.post(`${BASE_API_URL}/api/v1/users/change-password/`, body);
          if (response.data.success) {
            this.responseError = false;
            this.responseSuccess = true;
          }

        } catch (error) {
          console.log(error);
          this.responseError = true;
        }
      },
      finishUpdatePassword() {
        this.$emit('closeDialog');
        setTimeout(() => {
          this.responseError = false;
          this.responseSuccess = false;
          this.password = {
            old: '',
            new: '',
            newRep: ''
          };
          this.showPassword = {
            old: false,
            new: false,
            newRep: false
          };
        }, 500);
      },
      closeDialog() {
        this.$emit('closeDialog');
      }
    }
  }
</script>

<style scoped lang="scss">

</style>
